'use client'
import dynamic from 'next/dynamic'
import type { CheckoutPageStdProps } from './CheckoutPageStd'

const CheckoutPageStd = dynamic(() => import('./CheckoutPageStd'), { ssr: false })

export const CheckoutPageStdClient = (props: CheckoutPageStdProps) => {
  return <CheckoutPageStd {...props} />
}
